import { __ } from '@wordpress/i18n';
import apiFetch from '@wordpress/api-fetch';
import { registerBlockType, createBlock, BlockConfiguration } from '@wordpress/blocks';
import { useState } from "@wordpress/element";
import {
	Button,
	Flex
} from "@wordpress/components";
import { useSelect, useDispatch } from "@wordpress/data";
import { RichText } from "@wordpress/block-editor";
import { moreHorizontalMobile } from '@wordpress/icons';
import { pluginIcon, sendIcon } from "./icons";
import "./settings.tsx";

import blockJson from './block.json';

import './index.scss';

const metadata: BlockConfiguration = blockJson ?? {};

registerBlockType( metadata, {
	icon: pluginIcon,
	edit: props => {
		const { clientId }                = props;
		const [ prompt, setPrompt ]       = useState( '' );
		const [ isLoading, setIsLoading ] = useState( false );
		const dispatch                    = useDispatch( 'core/block-editor' );

		const { options, index } = useSelect( select => {
			return {
				options: select( 'core' )?.getEditedEntityRecord( 'root', 'site' ) ?? {},
				index: select( 'core/block-editor' )?.getBlockIndex( {}, clientId ) ?? 0,
			}
		}, [] );

		const apiKeyStatus = options?.aiBlock?.apiKeyStatus ?? 'invalid';

		// Send the user's message to the chatbot API and get the response.
		async function sendMessage() {
			if ( ! prompt ) {
				return;
			}

			setIsLoading( true );

			const response: string = await apiFetch( {
				path: '/ai-block/v1/completions/?prompt=' + encodeURI( prompt ) + '&max_tokens=' + options?.aiBlock?.maxTokens ?? 25,
				method: 'GET'
			} );

			console.log( response );

			if ( ! response ) {
				setIsLoading( false );

				return;
			}

			let responseBlocks = response
			?.split( '\n' )
			?.map( ( line: string ) => createBlock( 'core/paragraph', {
				content: line,
			} ) );

			responseBlocks = responseBlocks.filter( ( block: any ) => block.attributes.content !== '' );

			if ( ! responseBlocks ) {
				setIsLoading( false );

				return;
			}

			const group = createBlock( 'core/group', {}, responseBlocks );

			dispatch.insertBlock( group, index );

			setIsLoading( false );
		}

		return (
			<>
				<Flex
					className={ 'ai-block' }
					justify={ 'space-between' }
					gap={ '1em' }
				>
					<RichText
						value={ prompt }
						onChange={ ( newPrompt: string ) => setPrompt( newPrompt ) }
						placeholder={ __( 'How can I help today?', 'ai-block' ) }
						__unstableDisableFormats
						preserveWhiteSpace
						tagName={ 'p' }
						multiline={ false }
					/>

					<Button
						isSmall
						isBusy={ isLoading }
						disabled={ isLoading || ! prompt || apiKeyStatus !== 'valid' }
						onClick={ () => sendMessage() }
						label={ __( 'Send', 'ai-block' ) }
						icon={ isLoading ? moreHorizontalMobile : sendIcon }
					/>
				</Flex>
			</>
		)
	},
	save: () => null,
} );
